"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setTheme = exports.changeStyle = void 0;
var _model = require("@/assets/js/model.js");
//默认的对象数据

var changeStyle = exports.changeStyle = function changeStyle(obj) {
  for (var key in obj) {
    //重新赋值自己之前定义的less变量值
    document.getElementsByTagName("body")[0].style.setProperty("--".concat(key), obj[key]);
  }
};

//改变主题的方法
var setTheme = exports.setTheme = function setTheme(themeName) {
  var themeConfig = _model.model[themeName]; // 获取主题配置
  //判断点击的是不是 header头部主题类型样式
  if (themeName === 'headerthreme') {
    themeConfig.tabbackground = sessionStorage.getItem('threme-color');
    themeConfig.aside = sessionStorage.getItem('threme-aside');
  }
  //themeName 传递的是默认值 还是其他值 就是 model.js 中的 default 或者 dark
  sessionStorage.setItem("theme", themeName); // 保存主题到本地，下次进入使用该主题
  // 如果有主题名称，那么则采用我们定义的主题 
  //判断传递过来的 themeName 是否存在,如果没存在 model[themeName]获取不到你想要的数据 就会走else
  if (themeConfig) {
    sessionStorage.setItem("themeConfig", JSON.stringify(themeConfig)); // 保存主题色到本地
    changeStyle(themeConfig); // 改变样式
  } else {
    changeStyle(themeConfig);
  }
};